import { render, staticRenderFns } from "./Progress.vue?vue&type=template&id=2b4dce40&scoped=true&"
import script from "./Progress.vue?vue&type=script&lang=js&"
export * from "./Progress.vue?vue&type=script&lang=js&"
import style0 from "./Progress.vue?vue&type=style&index=0&id=2b4dce40&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2b4dce40",
  null
  
)

export default component.exports